import cx from 'classnames';

import { MDText } from 'i18n-react';

import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import aa from '../../../../../../client/assets_seller/partners/aa.svg';
import confused from '../../../../../../client/assets_seller/partners/confused.svg';
import goCompare from '../../../../../../client/assets_seller/partners/goCompare.svg';
import moneySuperMarket from '../../../../../../client/assets_seller/partners/moneySuperMarket.svg';
import octopus from '../../../../../../client/assets_seller/partners/octopusNew.svg';
import { PartnerLogos } from '../../../../../components/partnerLogos/PartnerLogos';

import LocalTexts from './LandingPagePartnerLogosTexts.json';

import styles from './LandingPagePartnerLogos.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

export const LandingPagePartnerLogos = () => {
  const TEXT = {
    aa: t('partner.altTexts.aa'),
    confused: t('partner.altTexts.confused'),
    goCompare: t('partner.altTexts.goCompare'),
    moneySuperMarket: t('partner.altTexts.moneySuperMarket'),
    octopus: t('partner.altTexts.octopus'),
    title: t('partner.title'),
  };

  const logos = [
    { alt: TEXT.aa, height: 40, id: 1, src: aa, width: 37.5 },
    { alt: TEXT.confused, height: 40, id: 2, src: confused, width: 145 },
    { alt: TEXT.octopus, height: 40, id: 3, src: octopus, width: 142.5 },
    {
      alt: TEXT.moneySuperMarket,
      height: 40,
      id: 4,
      src: moneySuperMarket,
      width: 107.5,
    },
    {
      alt: TEXT.goCompare,
      height: 40,
      id: 5,
      src: goCompare,
      width: 153.75,
    },
  ];

  const onRefTrigger = () => LANDING_PAGE_EVENTS.SECTION_LOAD({
    name: LANDING_PAGE_SECTIONS_NAMES.RECOMMENDED_BY,
  });

  return (
    <PartnerLogos {...{ onRefTrigger }}>
      {logos.map(({ alt, height, id, src, width }) => (
        <span key={id} className={cx(styles.logo, styles[`logo${id}`])}>
          <img
            loading="lazy"
            {...{ alt, height, src, width }}
          />
        </span>
      ))}
    </PartnerLogos>
  );
};
